import cns from 'classnames';
import cn from './styles.local.less';

type FontSize = 'l' | 'm' | 's';
type FontWeight = 'regular' | 'bold' | 'bolder' | 'black';
type FontTag = 'h2' | 'h3' | 'h4' | 'h5';

interface Props {
  tag?: FontTag;
  size?: FontSize;
  weight?: FontWeight;
  color?: string; // TODO brand colors
  className?: string;
  children: any;
}

export default function Text(props: Props) {
  const { size, tag, children, className } = props;
  const rootClassName = cns(cn.root, className, {
    [cn[`size_${size}`]]: !!size,
  });

  const Tag = tag || 'span';

  return <Tag className={rootClassName}>{children}</Tag>;
}
